import type { ApolloError } from '@apollo/client';
import { Alert, AlertTitle, Stack, Typography } from '@cmg/design-system';
import isEmpty from 'lodash/isEmpty';
import { useMemo } from 'react';

import { isGQLExtensionErrors } from '../../types/common';

type GQLExtensionErrorAlertProps = Readonly<{
  readonly title: string;
  readonly error?: ApolloError;
}>;

export function GQLExtensionErrorAlert({ title, error }: GQLExtensionErrorAlertProps) {
  const errorMessages = useMemo(() => {
    if (!error) {
      return [];
    }

    return error.graphQLErrors.flatMap(err =>
      isGQLExtensionErrors(err.extensions) ? err.extensions.errors?.map(e => e.message) : []
    );
  }, [error]);

  if (isEmpty(errorMessages)) {
    return null;
  }

  return (
    <Alert severity="error">
      <AlertTitle>{title}</AlertTitle>
      <Stack>
        {errorMessages.map((msg, index) => (
          <Typography key={`${index}-${msg}`} variant="body2">
            {msg}
          </Typography>
        ))}
      </Stack>
    </Alert>
  );
}
